import { useMutation } from "@tanstack/react-query";
import { financeApi } from "../../../finance-api-client";

/**
 * Start a self-serve upgrade to `tier` — returns a hosted Stripe Checkout URL the
 * caller redirects to. No cache to invalidate: the tier lands via the JWT claim
 * after the Stripe webhook fires.
 */
export function useUpgradeCheckout(clubId: string) {
	return useMutation({
		mutationFn: (tier: string) => financeApi.plan.createCheckout(clubId, tier),
	});
}

/** Open the hosted Stripe Customer Portal to change plan, update card, or cancel. */
export function useBillingPortal(clubId: string) {
	return useMutation({
		mutationFn: () => financeApi.plan.openPortal(clubId),
	});
}
